module.exports = __webpack_public_path__ + "img/icon_submenu6dark.3a90df5e.svg";